import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Skeleton from 'src/Admin/components/common/skeleton';
import './ApprovalRequest.scss';

const ApprovalDetailsSkeleton = () => {
  return (
    <>
      <div className="approval-request-container">
        <div className="mt-3 request-info-panel">
          <div className="request-data">
            <div className="flex-container">
              <div className="flex-item">
                <label>
                  <Skeleton count={1} height={20} width={250} />
                </label>
                <span>
                  <Skeleton count={1} height={25} width={300} />
                </span>
              </div>
              <div className="flex-item">
                <label>
                  <Skeleton count={1} height={20} width={250} />
                </label>
                <span>
                  <Skeleton count={1} height={25} width={300} />
                </span>
              </div>
              <div className="flex-item">
                <label>
                  <Skeleton count={1} height={20} width={250} />
                </label>
                <span>
                  <Skeleton count={1} height={25} width={300} />
                </span>
              </div>
              <div className="flex-item">
                <label>
                  <Skeleton count={1} height={20} width={250} />
                </label>
                <span>
                  <Skeleton count={1} height={25} width={300} />
                </span>
              </div>
              <div className="flex-item">
                <label>
                  <Skeleton count={1} height={20} width={250} />
                </label>
                <span>
                  <Skeleton count={1} height={25} width={300} />
                </span>
              </div>
              <div className="flex-item">
                <label>
                  <Skeleton count={1} height={20} width={250} />
                </label>
                <span>
                  <Skeleton count={1} height={25} width={300} />
                </span>
              </div>
            </div>
          </div>

          <div className="request-control">
            <div className="pr-4">
              {' '}
              <Skeleton count={1} height={40} width={100} />
            </div>
            <div>
              {' '}
              <Skeleton count={1} height={40} width={100} />
            </div>
          </div>
        </div>
        <div className="mt-3 request-edit-panel">
          <div className="edit-section">
            <div className="user-label-edit-button">
              <div className="user-label">
                <span>
                  <Skeleton count={1} height={22} width={131} />
                </span>
              </div>
              <div>
                {' '}
                <Skeleton count={1} height={32} width={80} />
              </div>
            </div>

            <div className="top-section">
              <div className="user-email">
                <div className="user-icon">
                  {' '}
                  <Skeleton height={60} width={60} count={1} circle={true} />
                </div>
                <div className="name-email-container">
                  {' '}
                  <Skeleton count={1} height={50} width={200} />
                </div>
              </div>
              <div className="user-type-data-container">
                <div className="heading">
                  <Skeleton count={1} height={16} width={140} />
                </div>
                <div className="data">
                  <Skeleton count={1} height={22} width={140} />
                </div>
              </div>
            </div>
            <div className="horizantal-divide"></div>
            <div className="affliation">
              <div className="user-label">
                <Skeleton count={1} height={30} width={100} />
              </div>
              <div>
                <Skeleton count={1} height={32} width={80} />
              </div>
            </div>
            <div className="affliation">
              <div className="user-label">
                <Skeleton count={1} height={20} width={120} />
              </div>
              <div>
                <Skeleton count={1} height={20} width={100} />
              </div>
            </div>
            <div className="affliation-accordion">
              <Skeleton count={1} height={60} width={780} />
              <Skeleton count={1} height={60} width={780} />
              <Skeleton count={1} height={60} width={780} />
            </div>
            <div className="horizantal-divide"></div>
            <div className="affliation">
              <div className="user-label">
                <Skeleton count={1} height={30} width={200} />
              </div>
              <div>
                <Skeleton count={1} height={20} width={100} />
              </div>
            </div>
            <div className="permissions">
              <Skeleton count={1} height={40} width={780} />
              <Skeleton count={1} height={40} width={780} />
              <Skeleton count={1} height={40} width={780} />
            </div>
            <div className="horizantal-divide"></div>
            <div className="affliation">
              <div className="user-label">
                <Skeleton count={1} height={30} width={250} />
              </div>
            </div>
            <div className="comment-field">
              {' '}
              <Skeleton count={1} height={40} width={730} />
            </div>
            <div className="request-control">
              <div className="pr-4">
                {' '}
                <Skeleton count={1} height={40} width={100} />
              </div>
              <div>
                {' '}
                <Skeleton count={1} height={40} width={100} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApprovalDetailsSkeleton;
